module.exports = __webpack_public_path__ + "static/media/vu-bypassed.7a74fc36.png";